// extracted by mini-css-extract-plugin
export default {"loader":"IROmww9Jt93jcjG","rotation":"EMEpsxzDXUzhnAO","small":"tTPLTbOv6IlJdUs","medium":"RfdQFPJdEppw0JK","large":"IyuxR9qt6N1YDHs"};